import { deleteTranslation } from '../../utils/delete-translation';

export const DeviceEditSceneTranslation = {
  fi: {
    DeviceEditScene: {
      title: 'Muokkaa älylääkekaapin tietoja',
      areYouSure: deleteTranslation('älylääkekaapin'),
    },
  },
};
